const setPerPage = (queryPerPage, localStoragePerPage, defaultPerPage) => queryPerPage || localStoragePerPage || defaultPerPage

export default setPerPage
